import { useEffect, useRef, useState } from 'react';
import {getRandomTransitionGif} from './medias/get-random-transition-gif.js'
import gsap from 'gsap'

export const Showcase = function ({radio, isPower, volume}) {
	const showcaseTransition = useRef()
	const radioName = useRef()
	const radioSound = useRef()
	const showcaseRef = useRef()
	const [isFirstRender, setFirstRender] = useState(true)

	useEffect(() => {
		showcaseTransition.current.src = getRandomTransitionGif()
		radioName.current.style.display = "none"
		setTimeout(() => {
			showcaseTransition.current.src = radio.cover
			radioName.current.style.display = "block"
		}, 400)
	}, [radio])

	useEffect(() => {
		if (isFirstRender) {
			setFirstRender(false)
			return
		}
		radioSound.current.style.display = "block"
		setTimeout(() => {
			radioSound.current.style.display = "none"
		}, 650)
	}, [volume])

	useEffect(() => {
			gsap.fromTo(showcaseRef.current, { scale: 0, duration: 0.1 }, { scale: 1, duration: 0.1 })
	  }, [isPower])
	
	return <div className='showcase-container crt' ref={showcaseRef}>
				<img
					ref={showcaseTransition}
					className='showcase-content'
				/>
				<span ref={radioName} className='radio-name'>{radio.title}</span>
				<span ref={radioSound} className='radio-sound'>Volume: {volume}</span>
		</div>
}
  